module.exports = __webpack_public_path__ + "static/media/my-cartoon-img.5f5da6f9.png";